const normalizationRegex = /[\u0300-\u036F]/g;

export const slugify = (string: string): string => {
  return string
    ?.toLowerCase()
    ?.normalize('NFD')
    ?.replace(normalizationRegex, '')
    ?.replace(/['’`´]/g, '-')
    ?.replace(/\s+/g, '-')
    ?.replace(/[^a-z0-9-]/g, '')
    ?.replace(/(?:-)+/g, '-')
    ?.replace(/^-+|-+$/g, '');
};
